export const GET_ARTICLES = 'GET_ARTICLES';
export const SET_ARTICLES = 'SET_ARTICLES';
